import { render, staticRenderFns } from "./RelatorioComercialSalesOrderDetalhadoView.vue?vue&type=template&id=22c68bd1&scoped=true"
import script from "./RelatorioComercialSalesOrderDetalhadoView.vue?vue&type=script&lang=js"
export * from "./RelatorioComercialSalesOrderDetalhadoView.vue?vue&type=script&lang=js"
import style0 from "./RelatorioComercialSalesOrderDetalhadoView.vue?vue&type=style&index=0&id=22c68bd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c68bd1",
  null
  
)

export default component.exports